import { render, staticRenderFns } from "./CallsDashboard.vue?vue&type=template&id=396bb350&"
import script from "./CallsDashboard.vue?vue&type=script&lang=js&"
export * from "./CallsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CallsDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports